import { Leaf, House, Wifi, Trees, ChevronDown } from 'lucide-react'
import { useLanguage } from '../context/LanguageContext'
import { sectionImages } from '../data/imageBank'

export default function Hero() {
  const { t } = useLanguage()
  const heroTitle = t('hero.title')
  	const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' })

  	return (
    	<section
      		id="home"
      		className="relative min-h-screen flex items-center justify-center overflow-hidden"
    	>
      	{/* Background */}
      	<div className="absolute inset-0">
        	<img
            	src={sectionImages.hero}
          		alt="Nature & Gîtes"
          		className="w-full h-full object-cover"
            		fetchPriority="high"
            		decoding="async"
          		onError={(e) => { e.target.style.display = 'none' }}
        	/>
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(to bottom, rgba(26,71,42,0.60) 0%, rgba(26,71,42,0.40) 50%, rgba(26,71,42,0.70) 100%)'
          }}
        />
        {/* Fallback gradient when no image */}
        <div
          className="absolute inset-0 -z-10"
          style={{ background: 'linear-gradient(135deg, #1a472a 0%, #2d6640 40%, #4a7c2a 100%)' }}
        />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">

        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-8">
          <Leaf className="w-4 h-4 text-ng-gold" />
          <span className="text-sm font-medium text-white/90">{t('hero.badge')}</span>
        </div>

        {/* H1 */}
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-white mb-6 tracking-tight font-bold">
          {heroTitle === 'hero.title' ? 'Nature & Gîtes' : heroTitle}
        </h1>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        {/* Feature pills */}
        <div className="flex flex-wrap justify-center gap-6 mb-12">
          {[
            { icon: <House className="w-5 h-5 text-ng-gold" />, label: t('hero.pill1') },
            { icon: <Wifi  className="w-5 h-5 text-ng-gold" />, label: t('hero.pill2') },
            { icon: <Trees className="w-5 h-5 text-ng-gold" />, label: t('hero.pill3') },
          ].map(({ icon, label }) => (
            <div key={label} className="flex items-center gap-2 text-white/80">
              {icon}
              <span className="text-sm">{label}</span>
            </div>
          ))}
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => scrollTo('#project')}
            className="px-8 py-4 bg-ng-gold text-white font-medium rounded-full hover:bg-[#b88a14] transition-colors shadow-lg hover:shadow-xl"
          >
            {t('hero.ctaProject')}
          </button>
          <button
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-medium rounded-full border border-white/30 hover:bg-white/20 transition-colors"
            onClick={() => scrollTo('#contact')}
          >
            {t('hero.ctaContact')}
          </button>
        </div>
      </div>

      {/* Scroll arrow */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollTo('#project')}
          aria-label={t('hero.ctaProject')}
          className="p-2 text-white/60 hover:text-white transition-colors"
        >
          <ChevronDown className="w-6 h-6" aria-hidden="true" />
        </button>
      </div>
    </section>
  )
}
